import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import * as actionTypes from '../../store/actions';
import './Layout.css';
import Toolbar from '../Navigation/Toolbar/Toolbar';
import Sidebar from '../Navigation/Sidebar/Sidebar';
import RightSidebar from '../Navigation/RightSideBar/RightSideBar';
import LeftMenu from '../Navigation/LeftMenu/LeftMenu';
import Router from './Router/Router';
import Inactivity from '../Security/Inactivity/Inactivity';

const Layout = (props) => {

    const [layoutState, setLayoutState] = useState({viewSidebar: false, viewRightSidebar: false});
    const [currentView, setCurrentView] = useState("login");
    const [displayLogin, setDisplayLogin] = useState(true);
    const [username, setUsername] = useState('');


    const logOut = () => {
        setUsername("")
        localStorage.setItem("arctoken", "");
        setCurrentView("login");
        setDisplayLogin(true);
    }

    const navIconClickedHandler = () => {
        if (currentView !== "login") {
            setLayoutState({viewSidebar: true, viewRightSidebar: false});
        }
    }

    const closeSidebar = () => {
        setLayoutState({viewSidebar: false, viewRightSidebar: false});
    }

    const rightMenuClickedHandler = () => {
        setLayoutState({viewSidebar: false, viewRightSidebar: true});
    }

    const closeRightSidebar = () => {
        setLayoutState({viewSidebar: false, viewRightSidebar: false});
    }

    const linkClickHandler = (name) => {
            setCurrentView(name);
            closeSidebar();
    }

    const homeClickHandler = () => {
        setCurrentView("specimens");
    }

    const loggedInSuccessfully = (configData, userData) => {
        props.updateConfig(configData);
        setUsername(userData.username)
        setCurrentView("home");
        setDisplayLogin(false);
    }

    // const savePreferences = (data) => {
    //     props.updatePreferences(data);
    // }

    let isLeftMenuVisible = true;
    if (props.showFullScreen !== undefined) {
        isLeftMenuVisible =  ! props.showFullScreen;
    }

    if (displayLogin) {
        isLeftMenuVisible =  false;
    }

    let menu = null;
    if (isLeftMenuVisible) {
        menu = (
            <div className="layout-menu">
                <LeftMenu currentView={currentView} clicked={navIconClickedHandler} sidebarContents = {props.sidebar} visible={true} clickLink={linkClickHandler}></LeftMenu>
            </div>
        );
    }

    let toolbar = null;
    if (!displayLogin) {
        toolbar = (
            <Toolbar clicked={navIconClickedHandler} rightclicked={rightMenuClickedHandler} logOut={logOut} navVisible={! isLeftMenuVisible} loginVisible={displayLogin} username={username}/>
        )
    }

    return (
        <React.Fragment>
            {toolbar}
            <main className="layout-main">
                {menu}
                <div className="layout-content">
                    <Router currentView={currentView} successfulLogin={loggedInSuccessfully} homeClick={homeClickHandler} ></Router>
                </div>
                <Sidebar currentView={currentView} sidebarContents = {props.sidebar} visible={layoutState.viewSidebar} closed={closeSidebar} clickLink={linkClickHandler}/>
                <RightSidebar sidebarContents={props.rightSidebar} visible={layoutState.viewRightSidebar} closed={closeRightSidebar}/>
            </main>
            <Inactivity enabled={!displayLogin} logOut={logOut} language={props.language}></Inactivity>
        </React.Fragment>
    )
};

const mapStateToProps = state => {
    return {
        sidebar: state.config.sidebar,
        rightSidebar: state.config.rightSidebar,
        showFullScreen: state.display.showFullScreen,
        language: state.config.language,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        updateConfig: (value) => dispatch({type: actionTypes.UPDATECONFIG, value: value})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
